export default __webpack_public_path__ + "static/logo-059f51e2a85b133823e7a819e23eed62.png";